import { getContext } from '@fiverr-private/fiverr_context';

/**
 * Enriches a URL with UTM parameters for tracking
 * @param baseUrl - The base URL to enrich (can be relative or absolute)
 * @param source - The source parameter value (e.g., 'hplo_catalog', 'header_lohp')
 * @param position - Optional position parameter to append to source
 * @returns The enriched URL with UTM parameters
 */
export const enrichUrlWithParams = (baseUrl: string, source: string, position?: number): string => {
    try {
        const { pageCtxId, url } = getContext();

        const currentUrl = new URL(url);
        const origin = currentUrl.origin;

        const urlObj = new URL(baseUrl, origin);

        const queryParams = new URLSearchParams();
        queryParams.set('source', source);

        if (position) {
            queryParams.set('pos', position.toString());
        }

        queryParams.set('context_referrer', 'lohp_brand');
        queryParams.set('ref_ctx_id', pageCtxId);

        const existingParams = urlObj.searchParams;

        queryParams.forEach((value, key) => {
            existingParams.set(key, value);
        });

        return urlObj.toString();
    } catch (error) {
        return baseUrl;
    }
};
